<template>
  <q-form ref="editForm">
    <c-card title="감사결과 보고서" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-12">
          보고서 출력
        </div>
      </template>
    </c-card>
  </q-form>
</template>

<script>
export default {
  name: 'hazop-plan-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        disabled: false,
      }),
    },
  },
  data() {
    return {
      hazopPlan: {
        plantCd: null,
        request: '',
        period: [],
        year: '',
        att: '',
        matrixNo: 0,
        userId: '',
        deptCd: '',
        col1: '',
        col3: '',
      },
      attItems: [
        { code: '1', codeName: '정기' },
        { code: '2', codeName: '수시' },
      ],
      matrixItems: [
        { matrixNo: 1, matrixNm: 'hazop-1' },
        { matrixNo: 2, matrixNm: 'hazop-2' },
      ],
      editable: true,
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.hazopPlan = {
        plantCd: '3',
        request: '안전환경팀/시스템/2021-01-01',
        period: ['2021-01-01', '2021-06-30'],
        year: '2021',
        att: '1',
        matrixNo: 1,
        userId: '1',
        deptCd: '',
        col1: '정기 hazop 평가',
        col3: 'XXXX 평가 상세내용',
      };
    },
  }
};
</script>
